export const baseUrl = process.env.REACT_APP_BASE_URL;
export const baseUrlApi = process.env.REACT_APP_API_URL;
export const BaseURLVoyager = process.env.REACT_APP_API_URL_VOYAGER;

/**
 * Mientras los webservices `obtener_boletas_mnt` y `obtiene_factura` no estén
 * publicados, `Api.GetBoletasMantencion()` y `Api.GetFactura()` devuelven data
 * simulada. Se enciende poniendo REACT_APP_MOCK_DOCUMENTOS=true en el .env.
 */
export const MockDocumentos = process.env.REACT_APP_MOCK_DOCUMENTOS === 'true';

/**
 * Sección de facturas de la página "Mis boletas". Mientras esté apagada no se
 * llama a `Api.GetFactura()` ni se dibuja su tabla. Se enciende poniendo
 * REACT_APP_FACTURAS_ENABLED=true en el .env.
 */
export const FacturasEnabled = process.env.REACT_APP_FACTURAS_ENABLED === 'true';
